<a
  mat-dialog-content
  target="_blank"
  href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=PrkGbPU14UyLz4eGbIhgHaJT4oqNuJ1MvRjG31DF9_VURUFZWlBVNzJYWUhFRUEwMVVYNUxPV01KSC4u&route=shorturl" target="_blank"
>
  <img
    src="https://prodbidscirclestorage.blob.core.windows.net/home-bids-board/Imagem Portal Bids.png"
  />
</a>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Fechar</button>
</div>
